// Local church directory.
//
// No verified church data has been supplied. Church names, websites, addresses,
// denominations, service times, transportation details, and descriptions must
// come from BCM leadership — do not add entries from search results, proximity,
// or assumption. While this array is empty the directory renders its public
// empty state.

export type LocalChurch = {
  id: string
  name: string
  website?: string
  address?: string
  /** e.g. "About 10 minutes from campus" */
  distanceFromUcf?: string
  serviceTimes?: string[]
  /** Rides, shuttles, or carpool information verified by BCM. */
  transportation?: string
  /** Short description verified by the church or BCM leadership. */
  description?: string
  /** Set true only when BCM confirms students currently attend here. */
  bcmStudentsAttend?: boolean
}

export const localChurches: LocalChurch[] = []
